import { render, staticRenderFns } from "./AddNewRequest.vue?vue&type=template&id=bf6f3a78&scoped=true&"
import script from "./AddNewRequest.vue?vue&type=script&lang=ts&"
export * from "./AddNewRequest.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewRequest.vue?vue&type=style&index=0&id=bf6f3a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6f3a78",
  null
  
)

export default component.exports